import {
    INSTAGRAM,
    FACEBOOK,
    LINKEDIN,
    PINTEREST,
    TWITTER,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';
import {
    CommunityInstagram,
    requestInstagramParams
} from '@/lib/analytics/pages/community/instagram';
import { CommunityTwitter, requestTwitterParams } from '@/lib/analytics/pages/community/twitter';
import { CommunityLinkedin, requestLinkedinParams } from '@/lib/analytics/pages/community/linkedin';
import {
    CommunityTiktokBusiness,
    requestTiktokBusinessParams
} from '@/lib/analytics/pages/community/tiktokBusiness';
import {
    CommunityFacebook,
    requestFacebookParams,
    requestFacebookOtherParameters
} from '@/lib/analytics/pages/community/facebook';
import { CommunityYoutube, requestYoutubeParams } from '@/lib/analytics/pages/community/youtube';
import {
    CommunityPinterest,
    requestPinterestParams
} from '@/lib/analytics/pages/community/pinterest';

export const CommunityConfig = (type) => {
    let config;
    let fields;
    let parameters;
    const waitForSPTransition = true;
    switch (type) {
        case INSTAGRAM:
            config = CommunityInstagram;
            fields = requestInstagramParams;
            break;
        case TWITTER:
            config = CommunityTwitter;
            fields = requestTwitterParams;
            break;
        case FACEBOOK:
            config = CommunityFacebook;
            fields = requestFacebookParams;
            parameters = requestFacebookOtherParameters;
            break;
        case LINKEDIN:
            config = CommunityLinkedin;
            fields = requestLinkedinParams;
            break;
        case PINTEREST:
            config = CommunityPinterest;
            fields = requestPinterestParams;
            break;
        case TIKTOK_BUSINESS:
            config = CommunityTiktokBusiness;
            fields = requestTiktokBusinessParams;
            break;
        case YOUTUBE:
            config = CommunityYoutube;
            fields = requestYoutubeParams;
            break;
    }
    return { config, fields, parameters, waitForSPTransition };
};
